import { PenLine } from 'lucide-react';
import { Button, Dialog, cn } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';
import { AuthImage } from '../../../shared/ui/AuthImage.js';
import { SignaturePad } from './SignaturePad.js';
import { useMySignature, useSaveSignature } from '../model/signature.queries.js';

/**
 * «MENING IMZOYIM» — ko'rish va ALMASHTIRISH.
 *
 * Tasdiqlash oynasidagi bo'lim (`SignatureSetup`) imzoni faqat BIR MARTA,
 * u yo'q paytda so'raydi. Almashtirish uchun alohida joy kerak: imzo yomon
 * chiqishi mumkin va uni tuzatib bo'lmasa, xodim hujjatlarda umrbod noto'g'ri
 * imzo bilan qolib ketardi.
 *
 * Eski imzo O'CHIRILMAYDI: unga eski hujjatlar tayanadi va o'chirilsa,
 * o'tgan oydagi trebovaniya imzosiz chiqib qolardi. Yangisi shunchaki
 * bugundan boshlab ishlatiladi.
 */
export const MySignatureDialog = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const signature = useMySignature();
  const save = useSaveSignature();

  const current = signature.data?.fileId ?? null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('signature.mine')}
      description={t('signature.dialogHint')}
      footer={
        <div className="flex w-full justify-end">
          <Button variant="ghost" onClick={onClose} disabled={save.isPending}>
            {t('signature.close')}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        {current === null ? (
          <p className="text-sm text-text-muted">{t('signature.emptyHint')}</p>
        ) : (
          <div className="flex flex-col gap-2">
            <p className="text-sm font-medium text-text">{t('signature.current')}</p>
            <div
              className={cn(
                'flex items-center justify-center rounded-[var(--radius-md)] border border-border',
                'bg-surface p-3',
              )}
            >
              <AuthImage
                src={`files/${current}`}
                alt={t('signature.current')}
                className="max-h-20"
              />
            </div>
            <p className="text-xs text-text-muted">{t('signature.replaceHint')}</p>
          </div>
        )}

        <div className="flex flex-col gap-2">
          <p className="flex items-center gap-2 text-sm font-medium text-text">
            <PenLine size={14} aria-hidden />
            {current === null ? t('signature.draw') : t('signature.new')}
          </p>
          <SignaturePad busy={save.isPending} onDone={(file) => save.mutate(file)} />
          {save.isError ? (
            <p className="text-xs text-danger">{t('signature.saveError')}</p>
          ) : null}
        </div>
      </div>
    </Dialog>
  );
};
